import '.a{display:flex;}.ssr-plugin'
import '.x{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.l{align-items:center;}.ssr-plugin'
import '.al{gap:0.5rem;}.ssr-plugin'
import '.ar{cursor:pointer;}.ssr-plugin'
import '.gr{padding:0.75rem;}.ssr-plugin'
import '.af{border-radius:1.25rem;}.ssr-plugin'
import '.am{border:var(--blue-border);}.ssr-plugin'
import '.ag{background-color:var(--shades-white);}.ssr-plugin'
import '.cy{transition:background-color 0.2s ease;}.ssr-plugin'
import '.df{width:2.5rem;}.ssr-plugin'
import '.dg{height:2.5rem;}.ssr-plugin'
import '.gs{color:var(--shades-blue-700);}.ssr-plugin'
import '.gt{font-size:0.9rem;}.ssr-plugin'
import '.az{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="a x b l al ar gr af am ag cy"
        style={{
          '&:hover': {
            backgroundColor: 'var(--shades-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="df dg a l x gs"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="gt gs az"
        >
          {label}
        </span>
      </styled.button>
    )
}